import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import Button from '../Common/Button';

const LogoutButton = ({ className }) => {
  const router = useRouter();
  const lang = useSelector(({ common }) => common?.language);
  return (
    <Button
      onClick={() => {
        localStorage.clear();
        Cookies.remove('userData');
        router.push(`${process.env.NEXT_PUBLIC_BACKEND_URL}/logout`);
      }}
      className={className}
    >
      {lang?.common?.logout}
    </Button>
  );
};

export default LogoutButton;
